// client/src/locales/en

const en = {
  translation: {
    form: {
      form_submit: 'Submit form',
      make_a_choice: 'Select an option',
    },
    general: {
      readMore: 'Read more',
      loading: 'Loading',
      close: 'Close',
    },
    blocks: {
      imageContainer: {
        error: 'Error loading image'
      },
      mapBlock: {
        visitWebsite: 'Visit website',
        map: 'Map',
        list: 'List',
      },
      milkPricesTableBlock: {
        labels: {
          year: 'Year',
          month: 'Month',
          guaranteed_price: 'Guaranteed price',
          average_price: 'Average price',
          protein: 'Protein',
          fat: 'Fat',
          lactose: 'Lactose',
        },
        months: {
          1: 'January',
          2: 'February',
          3: 'March',
          4: 'April',
          5: 'May',
          6: 'June',
          7: 'July',
          8: 'August',
          9: 'September',
          10: 'October',
          11: 'November',
          12: 'December',
        },
      },
    },
    searchbar: {
      label: 'What are you looking for?',
      placeholder: 'example: milk prices',
    },
    splash: {
      title_1: "Celebrating",
      title_2: "from grass to glass",
      button: 'Discover our stories'
    },
    header: {
      language: 'Language',
      en: 'English',
      nl: 'Nederlands',
    },
    footer: {
      links: {
        privacy: 'Privacy',
        terms_conditions: 'Terms & Conditions',
      },
      follow_us: 'Follow us',
      text: "Learn more about our history and cooperative at <a href='https://frieslandcampina.com' target='_blank'>frieslandcampina.com</a>"

    },
    404: {
      title: "Page not found",
      description: "The link appears to be broken or the page has been moved. Please go to our homepage instead.",
      text: "<p></p>",
      link: '/',
      homepage: 'To homepage',
    },
    cookiebar: {
      title: 'Welcome!',
      description:
        "Probably you're already familiair with companies who are settings cookies on your desktop, tablet or phone. Friesland Campina is also using cookies and you can choose which ones.",
      accept: 'Akkoord',
      complete: {
        title: 'Complete cookies',
        description:
          "Met behulp van deze cookies verbeteren we de website, maken we een koppeling met social media, kunt u video's bekijken en een adviseur zoeken.",
      },
      limited: {
        title: 'Beperkte cookies',
        description:
          "Met deze cookies kunt u een adviseur zoeken, video's bekijken en kunnen wij de website verbeteren.",
      },
      functional: {
        title: 'Functionele cookies',
        description:
          "Deze cookies zijn noodzakelijk voor het functioneren van de website. U kunt geen video's bekijken en geen adviseur zoeken.",
      },
      decline: 'No, decline',
      statement: 'Cookie statement',
      missing: 'You need to enable our cookies to view this video. <0>Click here</0> to enable cookies.',
      video_placeholder: "If you wish to view this video, you need to accept 'Video Cookies' as they are required for this functionality.",
      please: "Please",
      adjust: "adjust your cookie preferences here."
    },
    searchResults: {
      title: 'Your search',
      noSearchTerm: 'You haven\'t supplied a search term',
      types: {
        page: 'Page',
        news: 'News',
        story: 'Story',
      },
      noResults: 'No results found. Try again with these tips:',
      noResultsTips: {
        spelling: 'Check your spelling',
        describe: 'Describe your search differently',
        shorter: 'Make your search shorter',
      },
    },
    filter: {
      noResults: 'There are no results found when filtering on this category. Please select a different category or click <a href="/frieslandcampina-news/">here</a> to go to the news overview.'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
    },
    show_button: {
      more: 'Show more',
      less: 'Show less'
    },
    share_link: {
      title: 'Share on'
    },
    news: {
      categories: 'Categories:',
    },
    story: {
      categories: 'Categories:',
    },
    filters: {
      filter_on: 'Filter on:',
      category: 'Category',
      all_categories: 'All categories',
      year: 'Year',
      all_years: 'All years',
    },
    formMessage: 'Checking...',
    highlights: {
      title: 'Today at FrieslandCampina',
      footer_copy: 'Find out what else is going on at FrieslandCampina:',
      link_copy: 'Visit our newsroom',
      link_url: "/frieslandcampina-news/"
    }
  },
}

export default en;
